import { render } from "./ActionButton.vue?vue&type=template&id=be068806&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=be068806&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be068806"]])

export default __exports__